import React from 'react';
interface TooltipEntry {
  name?: string | number;
  value?: number | string | (number | string)[];
  color?: string;
  dataKey?: string | number | ((obj: unknown) => unknown);
}
interface ChartTooltipProps {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string | number;
  formatter: (value: number, key: string) => string;
  footer?: string;
}
export function ChartTooltip({
  active,
  payload,
  label,
  formatter,
  footer
}: ChartTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;
  return <div className="min-w-[200px] rounded-md border border-line bg-white px-3 py-2.5 text-xs shadow-lg" data-id="element-670" data-mp="2zlbmb9d2tnto">
      <div className="mb-1.5 font-semibold text-navy" data-id="element-671" data-mp="2vljljitxclyv">{label}</div>
      <ul className="space-y-1" data-id="element-672" data-mp="2qmyg94ztfc3k">
        {payload.map((p, i) => {
        const v = typeof p.value === 'number' ? p.value : null;
        return <li key={i} className="flex items-center justify-between gap-4" data-id="element-673" data-mp="trka8xgsy4m6" data-mpi={i}>
              <span className="flex items-center gap-1.5 text-ink-muted" data-id="element-674" data-mp="ovlegot59kbq">
                <span className="h-2 w-2 rounded-sm" style={{
              background: p.color
            }} data-id="element-675" data-mp="1wsk01ai3iss8" />
                {p.name}
              </span>
              <span className="font-medium tabular-nums text-ink" data-id="element-676" data-mp="21qbsq6qkeixh">{v === null ? '—' : formatter(v, String(p.dataKey))}</span>
            </li>;
      })}
      </ul>
      {footer && <p className="mt-2 border-t border-line pt-1.5 text-[11px] text-ink-subtle" data-id="element-677" data-mp="1ss9shtennub9">{footer}</p>}
    </div>;
}
export function LegendItem({
  color,
  label,
  dashed,
  line
}: {
  color: string;
  label: string;
  dashed?: boolean;
  line?: boolean;
}) {
  return <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-ink-muted" data-id="element-678" data-mp="26s14xppix2n5">
      {line ? <span className="h-0 w-4 border-t-2" style={{
      borderColor: color,
      borderStyle: dashed ? 'dashed' : 'solid'
    }} data-id="element-679" data-mp="2bpsyeo5tgwtg" /> : <span className="h-2.5 w-2.5 rounded-sm" style={{
      background: color
    }} data-id="element-680" data-mp="2zevmadr1nlwe" />}
      {label}
    </span>;
}